import { dynamicLoader } from '~/utils';

export const OpportunitiesPage = dynamicLoader({
  name: 'OpportunitiesPage',
  importFunc: () => import('./opportunities'),
});